// ----------------------------------------------------------------------
// <copyright file="Izenda.DashboardSubscriptionConstants.js" company="Izenda">
//  Copyright (c) 2015 Izenda, Inc.
//  ALL RIGHTS RESERVED
//
//  The entire contents of this file is protected by U.S. and
//  International Copyright Laws. Unauthorized reproduction,
//  reverse-engineering, and distribution of all or any portion of
//  the code contained in this file is strictly prohibited and may
//  result in severe civil and criminal penalties and will be
//  prosecuted to the maximum extent possible under the law.
//
//  RESTRICTIONS
//
//  THIS SOURCE CODE AND ALL RESULTING INTERMEDIATE FILES
//  ARE CONFIDENTIAL AND PROPRIETARY TRADE
//  SECRETS OF IZENDA INC. THE REGISTERED DEVELOPER IS
//  LICENSED TO DISTRIBUTE THE PRODUCT AND ALL ACCOMPANYING .NET
//  CONTROLS AS PART OF AN EXECUTABLE PROGRAM ONLY.
//
//  THE SOURCE CODE CONTAINED WITHIN THIS FILE AND ALL RELATED
//  FILES OR ANY PORTION OF ITS CONTENTS SHALL AT NO TIME BE
//  COPIED, TRANSFERRED, SOLD, DISTRIBUTED, OR OTHERWISE MADE
//  AVAILABLE TO OTHER INDIVIDUALS WITHOUT EXPRESS WRITTEN CONSENT
//  AND PERMISSION FROM IZENDA INC.
//
//  CONSULT THE END USER LICENSE AGREEMENT(EULA FOR INFORMATION ON
//  ADDITIONAL RESTRICTIONS.
//
//</copyright>
// ----------------------------------------------------------------------
//
/**
 * DashboardSubscriptionConstants
 */

import localizer from 'share/localization/Izenda.Localizer';

export default {
  get SEARCH_OPTION() {
    return [
      { value: 'All', label: localizer.getText('COMMON_LABEL_ALL') },
      { value: 'Name', label: localizer.getText('COMMON_LABEL_INSTANCE_NAME') },
      { value: 'Schedule', label: localizer.getText('COMMON_LABEL_SCHEDULE') },
      { value: 'FilterValueSelection', label: localizer.getText('COMMON_LABEL_FILTER_VALUE_SELECTION') },
      { value: 'DeliveryType', label: localizer.getText('COMMON_LABEL_DELIVERY_TYPE') },
      { value: 'DeliveryMethod', label: localizer.getText('COMMON_LABEL_DELIVERY_METHOD') }
    ];
  },
  get PAGE_TEXT() {
    return {
      AddText: localizer.getText('DASHBOARD_SUBSCRIPTION_CONSTANTS_PAGE_TEXT_ADD'),
      EditText: localizer.getText('DASHBOARD_SUBSCRIPTION_CONSTANTS_PAGE_TEXT_EDIT'),
      CopyText: localizer.getText('DASHBOARD_SUBSCRIPTION_CONSTANTS_PAGE_TEXT_COPY'),
      DeleteText: localizer.getText('DASHBOARD_SUBSCRIPTION_CONSTANTS_PAGE_TEXT_DELETE')
    };
  },
  get TABLE_DEF() {
    return {
      selectedValue: { key: 'selectedValue', width: 30, title: '', sortable: false },
      name: {
        key: 'name',
        width: 200,
        title: localizer.getText('COMMON_LABEL_INSTANCE_NAME'),
        sortable: true,
        columnKey: 'name'
      },
      schedule: {
        key: 'schedule',
        width: 450,
        title: localizer.getText('COMMON_LABEL_SCHEDULE'),
        sortable: true,
        columnKey: 'schedule'
      },
      filterValueSelection: {
        key: 'filterValueSelection',
        width: 300,
        title: localizer.getText('COMMON_LABEL_FILTER_VALUE_SELECTION'),
        sortable: true,
        columnKey: 'filterValueSelection'
      },
      deliveryType: {
        key: 'deliveryType',
        width: 300,
        title: localizer.getText('COMMON_LABEL_DELIVERY_TYPE'),
        sortable: true,
        columnKey: 'deliveryType'
      },
      deliveryMethodView: {
        key: 'deliveryMethodView',
        width: 150,
        title: localizer.getText('COMMON_LABEL_DELIVERY_METHOD'),
        sortable: true,
        columnKey: 'deliveryMethodView'
      },
      action: {
        key: 'action',
        width: 80,
        title: localizer.getText('COMMON_LABEL_ACTION'),
        sortable: false,
        fixed: true
      }
    };
  },
  get MESSAGE() {
    return {
      M01a: localizer.getText('DASHBOARD_SUBSCRIPTION_CONSTANTS_MESSAGE_DELETE_SUBSCRIBED_INSTANCE'),
      M01b: localizer.getText('DASHBOARD_SUBSCRIPTION_CONSTANTS_MESSAGE_DELETE_SELECTED_SUBSCRIBED_INSTANCE'),
      M03a: localizer.getText('DASHBOARD_SUBSCRIPTION_CONSTANTS_MESSAGE_RECURRENCE_END_DATE'),
      M03b: localizer.getText('DASHBOARD_SUBSCRIPTION_CONSTANTS_MESSAGE_START_DATE_CANNOT_AFTER_END_DATE'),
      M05: localizer.getText('DASHBOARD_SUBSCRIPTION_CONSTANTS_MESSAGE_NAME_ALREADY_EXIST'),
      requiredOccurrence: localizer.getText('DASHBOARD_SUBSCRIPTION_CONSTANTS_MESSAGE_OCCURRENCE_IS_REQUIRED')
    };
  }
};



// WEBPACK FOOTER //
// ./ui/logic/data/Izenda.DashboardSubscriptionConstants.js